function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWetDepositionPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 21.166666 21.166667",
    id: "svg19093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-275.83332)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.21950617,
      strokeOpacity: 1
    },
    id: "rect4518-85-4-79",
    width: 21.166666,
    height: 21.166666,
    x: -5.5511151e-17,
    y: 275.83331,
    rx: 10.583333,
    ry: 10.583333
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#472a0f",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19206792,
      strokeOpacity: 1
    },
    id: "rect4518-8-4-7-0-4",
    width: 18.520834,
    height: 18.520834,
    x: 1.3229064,
    y: 277.15625,
    rx: 9.260417,
    ry: 9.260417
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.18505871,
      strokeOpacity: 1
    },
    d: "m 12.699998,285.14327 c 0,1.28779 -1.00691,2.33175 -2.24898,2.33175 -1.2420597,0 -2.2489398,-1.04396 -2.2489398,-2.33175 0,-1.28781 1.5806102,-4.28283 2.2489398,-4.28283 0.66837,0 2.24898,2.99502 2.24898,4.28283 z",
    id: "path4678-5-9-9-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 17.21548,290.85725 -5.425509,5.42499 c 0.457817,-0.0302 0.892969,-0.0926 1.305346,-0.18241 l 5.242573,-5.24258 z",
    id: "rect8773-0-3-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 5.2415336,290.85725 -2.0665413,2.06654 c 0.1611762,0.19371 0.3343063,0.39019 0.5332995,0.58911 l 2.655652,-2.65565 z",
    id: "rect8773-0-3-4-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 8.2351485,290.85725 -3.5201992,3.51968 c 0.210021,0.15469 0.4335939,0.30569 0.6728275,0.45062 l 3.9697845,-3.9703 z",
    id: "rect8773-0-3-5-23-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 11.228763,290.85725 -4.5997173,4.59972 c 0.2602018,0.10882 0.53399,0.20966 0.821137,0.30127 l 4.9009933,-4.90099 z",
    id: "rect8773-0-3-5-2-7-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 14.221862,290.85725 -5.2632421,5.26325 c 0.3180821,0.0541 0.6489567,0.0975 0.9942535,0.12816 l 5.3914016,-5.39141 z",
    id: "rect8773-0-3-5-6-4-4"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.23334058,
      strokeOpacity: 1
    },
    id: "rect8773-0-2",
    width: 18.520834,
    height: 1.8520833,
    x: 1.3229064,
    y: 289.85626
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWetDepositionPoint);
export default __webpack_public_path__ + "static/media/icon-wet-deposition-point.145350e781ce8228d71a7f0c0db3674f.svg";
export { ForwardRef as ReactComponent };